import { useReveal } from "@/hooks/useReveal";

const stats = [
  { id: "s1", value: "1,280+", label: "已整理专题" },
  { id: "s2", value: "18", label: "今日更新" },
  { id: "s3", value: "1.2万", label: "话题讨论" },
  { id: "s4", value: "93%", label: "会员续订" },
];

export default function HeroSection() {
  const { ref, visible } = useReveal<HTMLDivElement>(0.1);

  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-200/40 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-80 w-80 rounded-full bg-accent-200/40 blur-3xl" />

      <div
        ref={ref}
        className={`relative mx-auto grid w-full grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-12 lg:gap-12 lg:py-20 ${
          visible ? "reveal is-visible" : "reveal"
        }`}
      >
        <div className="flex flex-col justify-center lg:col-span-7">
          <div className="flex flex-wrap items-center gap-2">
            <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              会员专属
            </span>
            <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              内部特权
            </span>
            <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              完整版开放
            </span>
          </div>

          <h1 className="font-heading mt-5 text-4xl font-bold leading-tight text-foreground-950 md:text-5xl lg:text-[56px]">
            黑料福利
            <span className="mt-2 block text-primary-600">会员专属解锁</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            开通黑料福利会员，解锁专属与内部内容，付费资源一网打尽。特权用户可
            <strong className="font-semibold text-foreground-900">提前看料、看完整版</strong>
            ，享受普通用户接触不到的高价值爆料与深度内容。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#plans"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-vip-crown-2-line text-lg" />
              立即开通会员
            </a>
            <a
              href="#topics"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-6 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-layout-masonry-line text-lg" />
              逛逛话题墙
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-4 border-t border-background-300/70 pt-8 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.id}>
                <p className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  {item.value}
                </p>
                <p className="mt-1 text-xs text-foreground-600 md:text-sm">{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative mx-auto w-full max-w-md lg:max-w-none">
            <div className="relative h-[380px] w-full overflow-hidden rounded-xl md:h-[480px] lg:h-[560px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20warm%20editorial%20collage%20of%20overlapping%20paper%20panels%20and%20film%20frames%2C%20amber%20and%20deep%20crimson%20light%20leaks%2C%20matte%20texture%2C%20soft%20grain%2C%20magazine%20cover%20aesthetic%2C%20abstract%20and%20artistic%2C%20no%20text%2C%20no%20faces%2C%20cohesive%20low%20saturation%20warm%20palette%2C%20high%20detail&width=900&height=1120&seq=hl-hero-01&orientation=portrait"
                alt="黑料福利专题合集封面"
                title="黑料福利专题合集封面 会员专属内容"
                className="h-full w-full object-top object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                  <i className="ri-fire-line" />
                  今日主推
                </span>
                <p className="font-heading mt-3 text-lg font-semibold leading-snug text-background-50 md:text-xl">
                  影视剧组幕后风波全记录：从建组到杀青的 47 天
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-background-200">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" /> 8.4万 阅读
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" /> 326 讨论
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-vip-crown-2-line" /> 会员可看完整版
                  </span>
                </div>
              </div>
            </div>

            <div className="absolute -left-3 top-6 hidden rounded-lg border border-background-200 bg-background-50 px-4 py-3 md:block">
              <p className="text-[11px] text-foreground-500">本周新增专题</p>
              <p className="font-heading text-xl font-bold text-primary-600">+36</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}